import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "App";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";

// Auth & Break Context Providers
import { AuthProvider } from "./AuthContext";
//import { BreakProvider } from "context/BreakContext"; // ✅ BreakProvider

const isResizeObserverLoopError = (value) => {
  const message = typeof value === "string" ? value : value?.message || "";

  return (
    message.includes("ResizeObserver loop completed with undelivered notifications") ||
    message.includes("ResizeObserver loop limit exceeded")
  );
};

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverLoopError(event.message) || isResizeObserverLoopError(event.error)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    if (isResizeObserverLoopError(event.reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <AuthProvider>
        {/* <BreakProvider>  */}
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
        {/* </BreakProvider> */}
      </AuthProvider>
    </SoftUIControllerProvider>
  </BrowserRouter>
);
